﻿(function ($, document) {

    $(document).ready(function () {

        if ($('#js-majestic-map').length > 0) {

            var locations = $.parseJSON($('#js-majestic-map').attr('data-locations'));

            var map = new Maplace({
                map_div: '#js-majestic-map',
                locations: locations
            }).Load();

            $('.js-view-on-map').click(function (e) {
                e.preventDefault();
                map.ViewOnMap($(this).data('mapIndex') + 1);
            }); 
        } 
    });

})(jQuery, document);